import { computed, Injectable } from '@angular/core';
import { UserService } from '../../../../../../../../../shared/services/user.service';
import { OrbitFormClaimService } from '../../../../../../services/orbit-form-claim.service';

@Injectable({
  providedIn: 'root',
})
export class SmartFixAnalyticsService {
  constructor(
    private orbitFormClaimService: OrbitFormClaimService,
    private userService: UserService
  ) {}

  private viewModel = computed(() => {
    const bundle = this.orbitFormClaimService?.state?.claimData?.bundle;
    const mandatoryData = this.orbitFormClaimService?.state?.claimData?.mandatoryData;
    const userData = this.userService?.userInfo;
    return {
      digitalID: userData?.['custom:digital_id'],
      customerID: userData?.sub,
      modelNumber: mandatoryData?.modelNumber,
      serialNumber: mandatoryData?.serialNumber,
      productName: `${bundle?.manufacturer} ${bundle?.productType}`,
      manufacturer: bundle?.manufacturer,
      planNumber: bundle?.planNumber,
      underManufacturerGuarantee: mandatoryData?.planInWarrantyPeriod,
      claimedAccountBrand: mandatoryData?.bookingOEM,
      claimedClientName: mandatoryData?.bookingOEM,
      claimedBookingReference: this.orbitFormClaimService?.bookingData()?.claimID,
      bundle,
      mandatoryData,
      userData,
    };
  });

  get vm() {
    return this.viewModel();
  }

  triggerSmartFixEvent(
    eventLabel: string,
    eventClaims: string,
    eventAction: string,
    eventCategory?: string,
    pagename?: string
  ): void {
    const gaTrack = {
      event: 'genericGAEvent',
      category: 'claims-2.0',
      clientName: 'DG Claims',
      eventClaims: eventClaims?.replace(/-dgx$/, '') as string,
      eventCategory: eventCategory || '',
      DigitalID: this.vm.digitalID || 'DigitalID not found',
      customerID: this.vm.customerID,
      planNumber: this.vm.planNumber,
      productName: this.vm.productName,
      UnderManufacturerGuarantee: this.vm.underManufacturerGuarantee,
      claimGroup: 'dgx',
      claimedModelNumber: this.vm.modelNumber,
      claimedSerialNumber: this.vm.serialNumber,
      claimedAccountBrand: this.vm.claimedAccountBrand,
      claimedManufacturer: this.vm.manufacturer,
      claimedClientName: this.vm.claimedClientName,
      excessClaimsMessage: 'NO',
      companyCode: this.vm.bundle?.companyCode,
      countryCode: this.vm.bundle?.countryCode,
    };

    window.dataLayer.push({
      ...gaTrack,
      ...{ pagename },
      eventLabel,
      eventAction,
    });
  }

  pageViewEvent(pagename: string) {
    const gaTrackPageView = {
      event: 'spa-pageview',
      clientName: 'DG Claims',
      category: 'claims-2.0',
      pagename: pagename,
      customerID: this.vm.customerID,
      planNumber: this.vm.planNumber,
      claimGroup: 'dgx',
      claimedModelNumber: this.vm.modelNumber,
      claimedSerialNumber: this.vm.serialNumber,
      claimedAccountBrand: this.vm.claimedAccountBrand,
      claimedManufacturer: this.vm.manufacturer,
      claimedClientName: this.vm.claimedClientName,
      productName: this.vm.productName,
      excessClaimsMessage: 'NO',
      companyCode: this.vm.bundle?.companyCode,
      countryCode: this.vm.bundle?.countryCode,
    };

    window.dataLayer.push({
      ...gaTrackPageView,
      ...{ pagename },
    });
  }
}
